import { FilterByOption, FILTER_STATE_CONFIG } from "~/components/build/Show/lib/filterConstants";
import { StateIcon } from "~/components/Playground/Node/BaseNode/StateIcon";
import { textColorForStep } from "~/components/Playground/Node/colors";

export function FilterStateIcon({ filter }: { filter: FilterByOption }) {
  const { state, outcome } = FILTER_STATE_CONFIG[filter];

  return (
    <StateIcon
      state={state}
      outcome={outcome}
      missingDependencies={[]}
      className={textColorForStep({
        state,
        outcome,
        missingDependencies: [],
      })}
    />
  );
}
